export enum UIErrorComponent {
  Fullscreen = 'Fullscreen',
  Card = 'Card',
  ForCTA = 'ForCTA',
  GameIsNotAProgress = 'GameIsNotAProgress',
}
